export default {
    emailAlertBiz: {
        common: {
            emailAutoComplete: {
                sendToTip: '請輸入收件人郵箱地址，多個郵箱之前請回車分隔',
                addEmail: '郵箱：',
                single: '個人',
                team: '團隊',
                teamManage: '管理我的團隊',
                teamCount: '{count}位成員',
                noMatchedTeam: '未匹配到任何團隊',
                noMatchedSingle: '未匹配到相關郵箱賬號',
                includeExternal: '含外部成員',
            },
            alertFrequency: {
                weekly: '每周',
                monthly: '每月',
                everyday: '每天',
                weekdays: [
                    null,
                    '周壹',
                    '周二',
                    '周三',
                    '周四',
                    '周五',
                    '周六',
                    '周日',
                ],
                date: '{n}日',
                lastDay: '最後壹日',
            },
            alertDialog: {
                createTitle: '監控提醒',
                cancel: '取消',
                submit: '提交',
            },
            commonModule: {
                sendTo: '發送給',
                self: '自己',
                frequency: '提醒頻次',
                alertNoUpdate: '無更新時仍然提醒我',
                errorEmail: '郵箱格式不正確',
                emailToOtherTips: '勾選此框以確認，您已獲得您輸入郵箱的用戶的同意。',
            },
        },
        discovery: {

        },
        chemical: {

        },
    },
};
